import { useSyncExternalStore } from 'react';

import { getSnapshot, reset, setOption, subscribe } from './store';

export function useFuzzySearchSettings() {
  const settings = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return { settings, setOption, reset };
}
